export const SIDEBAR_WIDTH = 292;
/** The icon rail: the collapsed menu and the Process editor's rail share it so the edge never jumps. */
export const SIDEBAR_WIDTH_NARROW = 80;
export const SIDEBAR_INSET = 18;
export const SIDEBAR_MOBILE_BREAKPOINT = 768;

/** Phones and short landscape screens: too little room for nested scroll areas or an open apps row. */
export const SMALL_SCREEN_QUERY = `(max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px), (max-height: 500px)`;
export const SIDEBAR_SINGLE_SCROLL_MEDIA = `@media ${SMALL_SCREEN_QUERY}`;
